import React, { Component } from 'react';
import * as RouterDom from 'react-router-dom';
import { connect } from 'react-redux';
import './Layout.scss';
import HelmetTitle from '../../helmet_title/HelmetTitle';
import { ILayoutMainProps, ILayoutMainState } from './interfaces';
import Sidebar from './elements/Sidebar';
import MainContent from './elements/MainContent';
import { MenuList } from '../../../types/menu';
import LayoutFooter from '../main/LayoutFooter';

class LayoutMain extends Component<ILayoutMainProps, ILayoutMainState> {
  constructor(props: ILayoutMainProps) {
    super(props);
    this.state = {
      isShowAplSidebar: false
    };
  }

  getSidebarItems(user) {
    const menuList: MenuList[] = [];
    const isolatedHomePage: any[] = [];
    const modMenuList: MenuList[] = [];
    if (user.menuHierarchy && user.menuHierarchy.length > 0) {
      user.menuHierarchy.map((menu, index) => {
        if (menu.name !== 'Home Page') {
          return menuList.push({
            name: menu.name,
            url: menu.url,
            icon: menu.icon,
            children: menu.children
          });
        }
        return isolatedHomePage.push({
          name: 'Overview',
          url: menu.url,
          icon: menu.icon,
          children: menu.children
        });
      });

      if (menuList.length > 0) {
        menuList.map((menu, index) => {
          if (menu.name === 'Back Office BCL&D') {
            return modMenuList.push({
              name: menu.name,
              url: menu.url,
              icon: menu.icon,
              children: [
                ...menu.children,
                {
                  name: 'Topic',
                  icon: '',
                  url: '/management/topic',
                  isMandatoryMenu: null,
                  menuCode: null,
                  children: null
                }
              ]
            });
          }
          if (menu.name === 'My Learning') {
            return modMenuList.push({
              name: menu.name,
              url: menu.url,
              icon: menu.icon,
              children: [...isolatedHomePage, ...menu.children]
            });
          }
          return modMenuList.push(menu);
        });
      }
    }

    return [...modMenuList];
  }

  onAppToogler() {
    this.setState({ isShowAplSidebar: !this.state.isShowAplSidebar });
  }

  render() {
    const user = this.props.auth;

    // console.log('user', user);
    const className = `b-container ${this.props?.classes || ''}`;

    return (
      <>
        {/* Default Title */}
        <HelmetTitle title="Beelajar" />

        <div className={className}>
          <div>
            {user && user.menuHierarchy && user.menuHierarchy.length > 0 ? (
              <Sidebar
                menuList={this.getSidebarItems(user)}
                user={user}
                theme={this.props.theme}
              />
            ) : null}
          </div>
          <MainContent
            user={user}
            classes={this.props.classesMain}
            menuList={this.getSidebarItems(user)}
            theme={this.props.theme}
          >
            {this.props.children}
            <LayoutFooter />
          </MainContent>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  auth: state.auth.userData
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RouterDom.withRouter(LayoutMain));
